import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=5622aa0d"
import script from "./ServiceInformation.vue?vue&type=script&lang=js"
export * from "./ServiceInformation.vue?vue&type=script&lang=js"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&id=5622aa0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports